export default __webpack_public_path__ + "static/media/avs_cover.9944e2dc.png";